module.exports = __webpack_public_path__ + "img/facilita.428ef753.png";